import { createRootRoute, Outlet, ScrollRestoration } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense, lazy } from 'react';
import { Auth0Provider } from '@/lib/auth/Auth0Provider';
import { TokenBridge } from '@/lib/auth/TokenBridge';

// Devtools loaded lazily — never in production bundles.
const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import('@tanstack/router-devtools').then((mod) => ({
        default: mod.TanStackRouterDevtools,
      })),
    );

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <Auth0Provider>
      <TokenBridge />
      <QueryClientProvider client={queryClient}>
        <ScrollRestoration />
        <main id="main" tabIndex={-1}>
          <Outlet />
        </main>
        <Suspense fallback={null}>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      </QueryClientProvider>
    </Auth0Provider>
  );
}
